"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgMinusFilledIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 26 26', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', d: 'M12.6 25.6c6.904 0 12.5-5.596 12.5-12.5S19.504.6 12.6.6.1 6.196.1 13.1s5.596 12.5 12.5 12.5M8.303 11.928h8.594c.65 0 1.172.523 1.172 1.172a1.17 1.17 0 0 1-1.172 1.172H8.303A1.17 1.17 0 0 1 7.131 13.1c0-.65.523-1.172 1.172-1.172' }) })));
});
exports.default = (0, react_1.memo)(SvgMinusFilledIcon);
